<div class="wrapper-modal-suggested-column">
  <div class="wrapper-content-modal-filter">
    <div class="header-modal-filter">
      <div class="title-modal-suggested">
        <span class="title">{{'NEW_TEXT.suggested_columns_to_choose' | translate}}</span>
        <span class="subtitle">{{'NEW_TEXT.columns_are_created_by_order_of_choice_select_any_number_of_columns' | translate}}.</span>
        <div class="wrapper-custom-search">
          <img class="icon-search" src="../../../assets/icons/outline/icon-search.svg" alt="">
          <input type="text" placeholder="{{'NEW_TEXT.search' | translate}}" [(ngModel)]="searchTerm" (ngModelChange)="filterColumns()">
          <div (click)="searchTerm = '';filterColumns()" class="wrapper-delete-search">
            <img src="../../../assets/icons/outline/icon-close.svg" alt="">
          </div>
        </div>
      </div>
      <div (click)="closeModal.emit()" class="custom-btn custom-btn--circle-outline">
        <img src="../../../../../../assets/icons/outline/icon-close-modal.svg" alt="">
      </div>
    </div>
    <div *ngIf="filteredColumns.length" class="content-modal-filter">
      <!--   Column   -->
      <div class="wrapper-content-select-artist">
        <div class="wrapper-custom-checkbox-select-topics">
          <label *ngFor="let column of filteredColumns">
            <input type="checkbox" (change)="onCheckboxChange($event, column)" name="radioname">
            <div class="custom-checkbox-select-topics">
              <div class="check-topic">
                <img src="../assets/icons/outline/icon-check.svg" alt="">
              </div>
              <div class="wrapper-select-topics-info">
                <span>{{column}}</span>
              </div>
            </div>
          </label>
        </div>
      </div>
      <div class="buttons-filter-modal">
        <div (click)="closeModal.emit()" class="custom-btn custom-btn--outline">
          <span>{{'NEW_TEXT.cancel' | translate}}</span>
        </div>
        <div (click)="saveColumns()" class="custom-btn custom-btn--primary">
          <span>{{'NEW_TEXT.save' | translate}}</span>
        </div>
      </div>
    </div>
    <div *ngIf="!filteredColumns.length" class="no-data-box">
      <span>{{'NEW_TEXT.no_data' | translate}}</span>
    </div>
  </div>
</div>
